import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { WindowModule, DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule, PDFModule, ExcelModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { DatePickerModule, DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { LayoutModule } from '@angular/cdk/layout';
import { PopupModule } from '@progress/kendo-angular-popup';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { EditorModule } from '@progress/kendo-angular-editor';
import { UploadModule } from '@progress/kendo-angular-upload';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { TaxLinesComponent } from './tax-lines/tax-lines.component';
import { TaxCodeComponent } from './tax-code.component';
import { TaxLinesEditComponent } from './tax-lines-edit/tax-lines-edit.component';
import { SharedComponentsModule } from '../../sharedComponents.module';

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        DropDownsModule,
        DateInputsModule,
        DatePickerModule,
        EditorModule,
        UploadModule,
        GridModule,
        TooltipModule,
        WindowModule,
        PDFModule,
        ChartsModule,
        GaugesModule,
        PDFExportModule,
        ExcelModule,
        ButtonsModule,
        InputsModule,
        ExcelExportModule,
        ScrollViewModule,
        DialogsModule,
        PopupModule,
        SharedComponentsModule

    ],
    declarations: [
        TaxCodeComponent,
        TaxLinesComponent,
        TaxLinesEditComponent
    ], 
    exports: [
        TaxCodeComponent
    ]
})
export class TaxCodeModule { }
